import { DnvUserRoleType } from '@customer-portal/shared';
import { CoBrowsingCompany } from '@customer-portal/shared/models';

export class UpdateDnvUserAccessType {
  static readonly type = '[Settings] Update DNV user Access Type';

  constructor(public dnvUserAccessType: DnvUserRoleType) {}
}

export class UpdateIsDnvUser {
  static readonly type = '[Settings] Update Is Dnv User';

  constructor(public isDnvUser: boolean) {}
}

export class UpdateSelectedCobrowsingCompany {
  static readonly type = '[Settings] Update Selected Cobrowsing Company';

  constructor(public selectedCompany: CoBrowsingCompany) {}
}

export class ResetSelectedCobrowsingCompany {
  static readonly type = '[Settings] Reset Selected Cobrowsing Company';
}

export class UpdateImpersonatedUser {
  static readonly type = '[Settings] Update Impersonated User';

  constructor(public impersonatedUserEmail: string | null) {}
}

export class GetCompanySuggestions {
  static readonly type = '[Settings] Get Company Suggestions';

  constructor(public searchText: string) {}
}

export class GetCompanySuggestionsSuccess {
  static readonly type = '[Settings] Get Company Suggestions Success';

  constructor(public suggestions: CoBrowsingCompany[]) {}
}

export class GetCompanySuggestionsError {
  static readonly type = '[Settings] Get Company Suggestions Error';

  constructor(public error: Error) {}
}
